function SettingsTabs({

    activeTab,

    setActiveTab,

}) {

    const tabs = [

        {
            key: "general",
            label: "General",
        },

        {
            key: "business",
            label: "Business",
        },

        {
            key: "commission",
            label: "Commission",
        },

        {
            key: "delivery",
            label: "Delivery",
        },

        {
            key: "tax",
            label: "Tax",
        },

        {
            key: "email",
            label: "Email",
        },

        {
            key: "sms",
            label: "SMS",
        },

        {
            key: "payment",
            label: "Payment",
        },

        {
            key: "branding",
            label: "Branding",
        },

        {
            key: "contact",
            label: "Contact",
        },

        {
            key: "social",
            label: "Social",
        },

        {
            key: "security",
            label: "Security",
        },

        {
            key: "maintenance",
            label: "Maintenance",
        },

    ];

    return (

        <div className="settings-tabs">

            {tabs.map((tab) => (

                <button

                    key={tab.key}

                    className={`settings-tab ${
                        activeTab === tab.key
                            ? "active"
                            : ""
                    }`}

                    onClick={() =>
                        setActiveTab(tab.key)
                    }

                >

                    {tab.label}

                </button>

            ))}

        </div>

    );

}

export default SettingsTabs;